import { select, Store } from '@ngrx/store';
import { State, User } from '@wam/shared';
import { Observable } from 'rxjs';
import { authenticationSelectors } from '@wam/authentication';
import { take } from 'rxjs/operators';
import { inject } from '@angular/core';

export abstract class WithAuthService {
  store = inject<Store<State>>(Store);

  protected withUser(): Observable<User> {
    return this.store.pipe(select(authenticationSelectors.getCurrentUser), take(1));
  }
}
